<!--
 * @FileDescription: 新增仓库（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-07-07（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div>
    <a-modal :title="title"  v-model="isShowModel" class="warehouse-model"  @ok="onCofrimForm"  @cancel="onCancel">
        <a-form :form="form"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 16 }"
        >
            <a-form-item label="仓库名称">
                <a-input placeholder="请输入仓库名称"
                         v-decorator="['storageName', { rules: [{ required: true, message: '请输入仓库名称' }] }]" />
            </a-form-item>
            <a-form-item label="仓库地址">
                <a-textarea placeholder="请输入仓库具体地址" style="min-height: 86px"
                            v-decorator="['storageAddress']" ></a-textarea>
            </a-form-item>
            <a-form-item label="店长">
                <a-select  v-decorator="['staffId', { rules: [{ required: false, message: '请选择负责人' }] }]"
                           placeholder="选择店长"
                           @change="changeStaff"
                >
                    <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
                    <a-select-option :value="item.id" v-for="item in agentList">{{item.name}}</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="联系电话">
                <a-input placeholder="请输入联系电话" :disabled="true" v-decorator="['contactMobile']" />
            </a-form-item>
            <a-form-item label="仓库图片">
                <v-picture :isRemarks="false" :imgUrlProp="imgUrl"  @onChangeImg="onChangeImg">
                    <div class="picture-right" slot="note" v-if="isEmpty(imgUrl.id)">
                        <div style="line-height: 20px">仅限一张，1:1图片</div>
                        <div style="line-height: 15px">小于300kb，支持jpg,jpeg,png,gif等主流格式</div>
                    </div>
                </v-picture>
            </a-form-item>
        </a-form>
    </a-modal>
    <a-modal :title="title1"
             v-model="isShowModel1"
             class="warehouse1-model"
             @ok="onCofrimForm1"
             :okText="okText"
             :cancelText="cancelText"
             @cancel="onCancel1">

    </a-modal>
    <a-modal :title="title2"
             v-model="isShowModel2"
             :okText="okText1"
             :maskClosable="false"
             :footer="null"
             class="location-model"
             >
        <div class="spare">
            <div class="spare-ul div-overflow">
                <div class="spare-top" id="spare-top">
                    全部区域
                    <a-popover trigger="click" placement="bottomLeft" v-model="locationPop">
                        <template slot="content">
                            <div class="tree-add">
                                <a-radio-group :options="plainOptions" v-model="addTreeValue" class="tree-radio" />
                                <a-input placeholder="请输入库位名称"  v-focus v-model="treeInput" class="tree-add-input"  @pressEnter="pressEnterAdd()"></a-input>
                                <div class="tree-btn">
                                    <a-button class="manage-btn1" @click.stop="onTreeAddSave(1)">取消</a-button>
                                    <a-button class="btn-save-next manage-btn1"  @click.stop="onTreeAddSave(2)">确认</a-button>
                                </div>
                            </div>
                        </template>
                        <img src="@/assets/image/add_address@2x.png" class="tree-img-add" @click="onAddDepart(1)"/>
                    </a-popover>
                </div>
                <a-spin :spinning="$store.state.tabLoding">
                    <a-tree  defaultExpandAll  @expand="expandTree" show-line  v-if="treeList.length">
                        <a-tree-node v-for="(item,index) in treeList" :key="item.id" >
                            <img src="@/assets/image/wenjianjia_2@2x.png" class="tree-img" v-if="item.isShow" slot="switcherIcon"/>
                            <img src="@/assets/image/wenjian_3@2x.png" class="tree-img" slot="switcherIcon" v-else/>
                            <span slot="title" class="tree-span"  @click="onClickTree(1,item,index)" id="tree-add">
                            <span  class="tree-span-title"  v-show="!item.isCheck">{{item.name}}</span>
                            <template v-if="item.isCheck">
                                 <a-input v-model="item.name"  class="tree-input" allowClear ref="inputs"   @pressEnter="pressEnter(item)"></a-input>
                                 <a-tooltip placement="bottom">
                                    <template slot="title">
                                      <span>添加</span>
                                    </template>
                                     <a-popover trigger="click" placement="bottomLeft" v-model="locationPop1">
                                        <template slot="content">
                                            <div class="tree-add">
                                                <a-radio-group :options="plainOptions" v-model="addTreeValue" @change.native="e => onChangeTreeAdd(e,2)" class="tree-radio" />
                                                <a-input placeholder="请输入库位名称" v-focus  v-model="treeInput" class="tree-add-input"   @pressEnter="pressEnterAdd()"></a-input>
                                                <div class="tree-btn">
                                                    <a-button class="manage-btn1" @click.stop="onTreeAddSave(1)">取消</a-button>
                                                    <a-button class="btn-save-next manage-btn1"  @click.stop="onTreeAddSave(2)">确认</a-button>
                                                </div>
                                            </div>
                                        </template>
                                       <img src="@/assets/image/add_shop@2x.png" class="tree-li-img1 tree-img-add" @click.stop="onAddDepart(2,item)"/>
                                    </a-popover>
                                  </a-tooltip>
                                  <a-tooltip placement="bottom">
                                    <template slot="title">
                                      <span>删除</span>
                                    </template>
                                     <img src="@/assets/image/lajitong_2@2x.png" class="tree-li-img2" @click.stop="onDelete(item,index)"/>
                                  </a-tooltip>
                            </template>
                        </span>
                            <a-tree-node v-for="(item1,index1) in item.childLocation" :key="item1.id" >
                                <img src="@/assets/image/wenjianjia_2@2x.png" class="tree-img" v-if="item1.isShow" slot="switcherIcon"/>
                                <img src="@/assets/image/wenjian_3@2x.png" class="tree-img" slot="switcherIcon" v-else/>
                                <span slot="title" class="tree-span"  @click="onClickTree(2,item1,index,index1)" id="tree-add">
                                <span  class="tree-span-title"  v-show="!item1.isCheck">{{item1.name}}</span>
                                <template v-if="item1.isCheck">
                                     <a-input v-model="item1.name"  class="tree-input" allowClear ref="inputs"  @pressEnter="pressEnter(item1)"></a-input>
                                     <a-tooltip placement="bottom">
                                        <template slot="title">
                                          <span>添加</span>
                                        </template>
                                          <a-popover trigger="click" placement="bottomLeft" v-model="locationPop2">
                                                <template slot="content">
                                                    <div class="tree-add">
                                                        <a-radio-group :options="plainOptions" v-model="addTreeValue" @change.native="e => onChangeTreeAdd(e,3)" class="tree-radio" />
                                                        <a-input placeholder="请输入库位名称" v-focus  v-model="treeInput" class="tree-add-input"   @pressEnter="pressEnterAdd()"></a-input>
                                                        <div class="tree-btn">
                                                            <a-button class="manage-btn1" @click.stop="onTreeAddSave(1)">取消</a-button>
                                                            <a-button class="btn-save-next manage-btn1"  @click.stop="onTreeAddSave(2)">确认</a-button>
                                                        </div>
                                                    </div>
                                                </template>
                                               <img src="@/assets/image/add_shop@2x.png" class="tree-li-img1 tree-img-add" @click.stop="onAddDepart(3,item1,item)"/>
                                          </a-popover>
                                      </a-tooltip>
                                      <a-tooltip placement="bottom">
                                        <template slot="title">
                                          <span>删除</span>
                                        </template>
                                         <img src="@/assets/image/lajitong_2@2x.png" class="tree-li-img2" @click.stop="onDelete(item1,index1,index)"/>
                                      </a-tooltip>
                                </template>
                            </span>
                                <a-tree-node v-for="(item2,index2) in item1.childLocation" :key="item2.id"  isLeaf  >
                                    <img src="@/assets/image/wenjian_1@2x.png" class="tree-img1" slot="switcherIcon"/>
                                    <span slot="title" class="tree-span"  @click="onClickTree(3,item2,index,index1,index2)" id="tree-add">
                                    <span  class="tree-span-title"  v-show="!item2.isCheck">{{item2.name}}</span>
                                    <template v-if="item2.isCheck">
                                         <a-input v-model="item2.name"  class="tree-input" allowClear ref="inputs"  @pressEnter="pressEnter(item2)"></a-input>
                                          <a-tooltip placement="bottom">
                                            <template slot="title">
                                              <span>删除</span>
                                            </template>
                                             <img src="@/assets/image/lajitong_2@2x.png" class="tree-li-img2" @click.stop="onDelete(item2,index2,index1,index)"/>
                                          </a-tooltip>
                                    </template>
                                </span>
                                </a-tree-node>
                            </a-tree-node>
                        </a-tree-node>
                    </a-tree>
                </a-spin>
            </div>
        </div>
    </a-modal>
      <delete-modal ref="deletemodal" @confirmDeletion="confirmDeletion"></delete-modal>
  </div>
</template>
<script>
import picture from '@/components/upload/picture'
import {storageAdd,getPageAccount,storageUpdate,LocationUpdate,LocationAdd,LocationDelete,locationAllList} from "@/utils/api";
import {mixins} from "@/mixins/mixins";
import ATextarea from "ant-design-vue/es/input/TextArea";
import deleteModal from '@/components/module/deleteModal.vue'
import pick from 'lodash.pick'
import recordData from '@/mixins/shop.json'
export default {
    mixins:[mixins],
    data(){
        return{
            title:'新增仓库',
            form: this.$form.createForm(this),
            isShowModel:false,
            title1:'新增仓库成功，是否需要添加库位',
            isShowModel1:false,
            cancelText:'不需要',
            okText:'需要',
            okText1:'保存',
            title2:'设置库位',
            isShowModel2:false,
            treeList:[],
            plainOptions:[
                {label: '添加下级分类', value: '1'},
                {label: '添加同级分类', value: '2'}
            ],
            addTreeValue:'1',
            treeInput:'',
            selectedIndex:[],
            classList:['spare-top','tree-add'],
            locationPop:false,
            locationPop1:false,
            locationPop2:false,
            imgUrl:{
                url:'',
                id:''
            },
            imgId:'',
            model:{},
            delId:'',
            locationId:'',
            addObj:{},
            spinning: true,
        }
    },
    watch: {

    },
    mounted () {
        this.agentListSelect()
    },
    created () {

    },
    components: {
        ATextarea,
        'v-picture':picture,
        deleteModal
    },
    methods: {
        /**
        * @description: 此为方法注释（方法描述）
        * @param {参数类型} 参数名称
        * @return void
        */
        onOpen(index,record){
            this.model = {}
            this.form = this.$form.createForm(this)
            this.model = Object.assign({},record)
            this.imgUrl = {
                url:'',
                id:''
            }
            this.imgId = ''
            this.isShowModel = true
            if(index == 2){
                this.title = '编辑仓库'
                this.$nextTick(() => {
                    this.imgUrl.url = this.model.storageResourceUrl
                    this.imgUrl.id = this.model.storageResourceId
                    this.form.setFieldsValue(pick(this.model,'contactMobile','contactName','id','staffId','storageAddress','storageName',
                            'storageResourceId','storageResourceUrl'))
                });
            }else{
                this.title = '新增仓库'
            }
        },
        onChangeImg(id){
            this.imgId = id
        },
        onCofrimForm(){
            this.form.validateFields((err, values) => {
                if (!err) {
                    values.companyStoreId = this.$store.state.shopId
                    values.companyId =  this.$store.state.companyId
                    values.storageResourceId = !this.isEmpty(this.imgId) ? this.imgId :this.imgUrl.id
                    if(!this.isEmpty(this.model.id)){
                        values.id = this.model.id
                        storageUpdate(values,{}).then((res)=>{
                            if(res.success){
                                this.locationId = this.model.id
                                this.$message.success(res.logMessage)
                                this.isShowModel = false
                                this.getLocation()
                                this.$emit('onPageList')
                            }else{
                                this.locationId = res.result.id
                                this.$message.warn(res.logMessage)
                            }
                        })
                    }else{
                        storageAdd(values,{}).then((res)=>{
                            if(res.success){
                                this.$emit('onPageList')
                                this.$message.success(res.logMessage)
                                this.isShowModel1 = true
                                this.locationId = res.result
                                this.getLocation()
                            }else{
                                this.$message.warn(res.logMessage)
                            }
                        })
                    }
                }else{
                    this.$message.warn('您还有必填数据没有填写哦~')
                }
            })
        },
        /**
         * @description: 库位（方法描述）
         */
        getLocation(){
            this.treeList = []
            let data = {
                storageId:this.locationId,
                companyStoreId:this.$store.state.shopId,
            }
            data = this.$qs.stringify(data)
            locationAllList(data,{}).then((res)=>{
                if(res.success){
                    res.result.forEach((item)=>{
                        item.name1 = item.name
                        item.isCheck = false
                        item.isShow = false
                        if(item.childLocation.length > 0){
                            item.childLocation.forEach((item1)=>{
                                item1.name1 = item1.name
                                item1.isCheck = false
                                item1.isShow = false
                                if(item1.childLocation.length > 0){
                                    item1.childLocation.forEach((item2)=>{
                                        item2.name1 = item2.name
                                        item2.isCheck = false
                                        item2.isShow = false
                                    })
                                }
                            })
                        }
                    })
                    this.treeList = res.result
                    this.$store.state.tabLoding = false
                }
            })
        },
        onCancel(){
            this.isShowModel = false
            this.isShowModel3 = false
        },
        onOpen1(item){
            this.locationId = item.id
            this.isShowModel2 = true
            this.getLocation()
        },
        onCofrimForm1(){
            this.isShowModel1 = false
            this.isShowModel  = false
            this.isShowModel2 = true
            this.getLocation()
        },
        onCancel1(){
            this.isShowModel1 = false
            this.isShowModel  = false
        },
        onCofrimForm2(){
            this.isShowModel2 = false
        },
        onCancel2(){
            this.isShowModel2 = false
        },
        /**
         * @description: 库位的展开和收起
         */
        expandTree(expandedKeys,info){
            this.classList.forEach((item)=>{
                if(item.id == info.node.eventKey){
                    item.isShow = info.expanded
                    return;
                }
                if(item.childLocation){
                    item.childLocation.forEach((item1)=>{
                        if(item1.id == info.node.eventKey){
                            item1.isShow = info.expanded
                            return;
                        }
                    })
                }
            })

        },
        /**
         * @description: 添加库位的分级
         */
        onAddDepart(index,item,item1){
            setTimeout(()=>{
                let len = document.getElementsByClassName('tree-add-input')
                for(let i = 0;i<len.length;i++){
                    len[i].onclick = function (event) {
                        event.stopPropagation()
                    }
                }
            },20)
            this.addTreeValue = '1'
            this.addObj={
                index:index,
                item:item,
                item1:item1
            }
            if(index != 1){
                this.plainOptions = [
                    {label: '添加下级分类', value: '1'},
                    {label: '添加同级分类', value: '2',disabled: false }
                ]
                // setTimeout(()=>{
                //     this.$refs.inputss[0].focus()
                // },20)
            }else if(index == 1){
                this.plainOptions = [
                    {label: '添加下级分类', value: '1'},
                    {label: '添加同级分类', value: '2',disabled: true }
                ]
                // setTimeout(()=>{
                //     this.$refs.inputss.focus()
                // },20)
            }
        },
        /**
         * @description: 点击库位的几级菜单
         */
        onClickTree(rowIndex,item,index,index1,index2){
            this.closeIconBlock()
            item.isCheck = !item.isCheck
            this.$nextTick(()=>{
                this.$refs.inputs[0].focus()
                this.$refs.inputs[0].select()
                let inputLen = document.getElementsByClassName('tree-input')
                console.log(inputLen)
                for(let i = 0;i<inputLen.length;i++){
                    inputLen[i].onclick = function(event){
                        event.stopPropagation()
                    }
                }
                this.locationPop = false
                this.locationPop1 = false
                this.locationPop2 = false
            })
        },
        /**
         * @description: 库位添加时选择同级分类还是子级分类（方法描述）
         */
        onChangeTreeAdd(e,index){
            this.addTreeValue =  e.target.value
            if(index == 1){
                this.locationPop = true
            }else if(index == 2){
                this.locationPop1 = true
            }else if(index == 3){
                this.locationPop2 = true
            }
            event.stopPropagation();
        },
        /**
         * @description: 库位添加取消和确定按钮
         */
        onTreeAddSave(index){
            if(index == 2){
                if(this.isEmpty(this.treeInput)){
                    this.$message.warn('请输入库位名称')
                    return;
                }
                let data = {
                    name:this.treeInput,
                    companyStoreId:this.$store.state.shopId,
                    storageId:this.locationId,
                    parentId:''
                }
                if(this.addObj.index == 1 || (this.addObj.index == 2 && this.addTreeValue == 2)){
                    data.parentId = ''
                }else{
                    if(this.addTreeValue == 1){
                        data.parentId = this.addObj.item.id
                    }else{
                        data.parentId = this.addObj.item1.id
                    }
                }
                LocationAdd(data,{},{
                    companyStoreId:this.$store.state.shopId,
                }).then((res)=>{
                    if(res.success){
                        this.$store.state.tabLoding = true
                        this.getLocation()
                    }else{
                        this.$message.warn(res.logMessage)
                    }
                })
            }
            this.treeInput = ''
            this.locationPop = false
            this.locationPop1 = false
            this.locationPop2 = false
        },
        pressEnterAdd(){
            this.onTreeAddSave(2)
        },
        /**
         * @description: 库位修改
         */
        pressEnter(item){
            item.isCheck = !item.isCheck
            LocationUpdate({
                id:item.id,
                name:item.name,
                storageId:this.locationId
            },{},{
                companyStoreId:this.$store.state.shopId,
            }).then((res)=>{
                if(res.success){
                    this.$store.state.tabLoding = true
                    this.getLocation()
                }
            })
        },
        /**
         * @description: 失去焦点事件（方法描述）
         */
        closeIconBlock(){
            this.treeList.forEach((ch)=>{
                ch.isCheck = false
                if(this.isEmpty(ch.name) || ch.name != ch.name1){
                    ch.name = ch.name1
                }
                if(ch.childLocation.length > 0){
                    ch.childLocation.forEach((ch1)=>{
                        ch1.isCheck = false
                        if(this.isEmpty(ch1.name) || ch1.name != ch1.name1){
                            ch1.name = ch1.name1
                        }
                        if(ch1.childLocation.length > 0){
                            ch1.childLocation.forEach((ch2)=>{
                                ch2.isCheck = false
                                if(this.isEmpty(ch2.name) || ch2.name != ch2.name1){
                                    ch2.name = ch2.name1
                                }
                            })
                        }
                    })
                }
            })
        },
        /**
         * @description: 删除库位对应的级（方法描述）
         */
        onDelete(item,index){
            if(this.$comm.has('library_warehouse_delete')){
                item.content = '确定要删除该库位吗？'
                this.$refs.deletemodal.show(item)
            }else{
                this.$message.warn('您没有权限进行此操作')
            }
        },
        confirmDeletion(item){
            LocationDelete({},{},{
                id:item.id,
                companyStoreId:this.$store.state.shopId
            }).then((res)=>{
                if(res.success){
                    this.$store.state.tabLoding = true
                    this.getLocation()
                    this.$message.success(res.logMessage)
                }else{
                    this.$message.warn(res.logMessage)
                }
            })
        },
        /**
         * @description: 仓库新增或修改时选择负责人（方法描述）
         */
        changeStaff(value){
            this.agentList.forEach((item)=>{
                if(item.id == value){
                    this.form.setFieldsValue({
                        contactMobile:item.mobile
                    })
                }
            })
        },
    },

}
</script>
<style  lang="scss">
    .warehouse-model{
        width: 680px !important;
        height: 650px !important;
    }
    .location-model{
        width: 720px !important;
        height: 660px !important;
        .ant-spin-spinning{
            width: 100%;
            padding-top: 100px;
        }
    }
.warehouse1-model{
    width: 471px !important;
    height: 160px !important;
    .ant-modal-body{
        padding: 0;
    }
}
.ant-popover-inner-content{
    padding: 15px 16px 15px 16px !important;
}

.spare{
    width: 590px;
    height: 500px;
    overflow: hidden;
    border: 1px solid #EBEBEB;
    margin: 0 auto;
    .spare-ul{
        height: 500px;
        overflow-y: auto;
        overflow-x: hidden;
        padding: 20px 0 0 24px;
        .spare-top{
            color: #333333;
            font-size: 16px;
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            img{
                width: 16px;
                margin-left: 10px;
            }
        }
        .tree-img{
            width: 15px;
        }
        .tree-img1{
            width: 10px;
        }
        .ant-form-inline .ant-form-item{
            width: 100%;
            margin-bottom: 0 !important;
            .ant-form-item-control-wrapper{
                width: 100%;
            }
        }
        .ant-tree-treenode-selected {
            color: #565656;
            font-size: 14px;
        }
        .ant-tree li .ant-tree-node-content-wrapper{
            width: calc(100% - 13px);
            vertical-align: baseline;
        }
        .ant-tree li{
            padding: 0 !important;
        }
        .ant-tree.ant-tree-directory > li span.ant-tree-node-content-wrapper::before, .ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-node-content-wrapper::before{
            height: 36px !important;
        }
        .ant-tree li span.ant-tree-switcher, .ant-tree li span.ant-tree-iconEle{
            line-height: 30px !important;
        }
        .ant-tree li .ant-tree-node-content-wrapper{
            line-height: 36px !important;
            flex: 1;
            height: 36px;
        }
        .tree-span{
            display: flex;
            align-items: center;
            width: 100%;
            height: 30px;
            line-height: 30px;
            .tree-span-title{
                display: inline-block;
                width: 84px;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
            }
            .tree-li-img1{
                width: 12px;
                margin-left: 20px;
            }
            .tree-li-img2{
                width: 14px;
                margin-left: 14px;
            }
        }
        .tree-input{
            width: 150px;
            .ant-input{
                height: 28px !important;
                line-height:28px !important;
            }
        }
        .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected{
            background:rgba(247,111,20,0.1);
        }
    }
}
.tree-add{
    border-radius: 6px;
}
.tree-add-input{
    width: 240px;
    margin: 20px 0;
}
.tree-btn{
    display: flex;
    align-items: center;
    justify-content: center;
    .manage-btn1{
        width: 80px;
        height: 36px;
    }
    .btn-save-next{
        margin-left: 15px;
    }
}
.tree-radio{
    display: flex;
}
.del-ti{
    display: flex;
    justify-content: center;
    img{
        width: 24px;
        margin-right: 16px;
    }
}

</style>
